export default __webpack_public_path__ + "static/media/RecaptchaLogo.25df5875.svg";